import { getSelectBooleanFlag } from './select-flags';

export const selectShouldExposeVideoManageCaptions = getSelectBooleanFlag(
  'expose-video-manage-captions'
);
